import { useIncomingInvoiceService } from "serviceHooks";
import { FileHelper } from "utils/helpers";

function useIncomingInvoiceDownload(invoiceId: number) {
  const incomingInvoiceService = useIncomingInvoiceService();
  const onDownloadClick = () => {
    return incomingInvoiceService.getPdf(invoiceId).then((res) => {
      FileHelper.download(res);
    });
  };

  return onDownloadClick;
}

export default useIncomingInvoiceDownload;
